import { render } from "./JobItem.vue?vue&type=template&id=51402340&scoped=true&ts=true"
import script from "./JobItem.vue?vue&type=script&lang=ts"
export * from "./JobItem.vue?vue&type=script&lang=ts"

import "./JobItem.vue?vue&type=style&index=0&id=51402340&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51402340"]])

export default __exports__